import { render, staticRenderFns } from "./Update-Contact-Person.vue?vue&type=template&id=97050890"
import script from "./Update-Contact-Person.vue?vue&type=script&lang=js"
export * from "./Update-Contact-Person.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports